import type {ReactElement} from 'react';
import React from 'react';
import {Snackbar} from '@Components/snackbar';
import {SnackbarMessageGrowl} from '@Components/snackbar-message-growl';

export function AiChatLoadingStates(): ReactElement {
  return (
    <div className={'_position-absolute _full-width _full-height'}>
      <Snackbar zIndex={5002} />
      <SnackbarMessageGrowl zIndex={5002} />
    </div>
  );
}
